<template>
  <v-row justify="center">
    <v-dialog
        :value="true"
        persistent
        max-width="900px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h6">Survey for {{ survey.customer.name }}</span>
        </v-card-title>
        <v-card-text>
          <span class="text-body-2">Address: {{ survey.address }}</span><br />
          <span class="text-body-2">Date: {{ survey.date | shortDate }}</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              small
              color="blue-grey lighten-4"
              @click="$store.commit('setSurvey', 0)"
          >
            <v-icon left>
              mdi-close
            </v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'SelectedJob',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      survey: {},
    };
  },
  methods: {
    getSurvey() {
      axios.get(`/siteSurveys/getOne/${this.$store.state.selectedSurveyId}.json?token=${this.token}`)
        .then((response) => {
          this.survey = response.data.survey;
        });
    },
  },
  mounted() {
    this.getSurvey();
  },
};
</script>
